import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProvenueErrorService {
  #pvRequestId: string;
  #pvProxyRequestId: string;

  constructor() {
    this.#pvRequestId = '';
    this.#pvProxyRequestId = '';
  }

  setPvRequestId(pvRequestId: string | null) {
    if (!pvRequestId) {
      this.#pvRequestId = '';
      return;
    }

    this.#pvRequestId = pvRequestId;
  }

  setPvProxyRequestId(pvProxyRequestId: string | null) {
    if (!pvProxyRequestId) {
      this.#pvProxyRequestId = '';
      return;
    }

    this.#pvProxyRequestId = pvProxyRequestId;
  }

  getPvRequestId() {
    return this.#pvRequestId;
  }

  getPvProxyRequestId() {
    return this.#pvProxyRequestId;
  }

  logProvenueIds() {
    console.log('pvRequestId', this.#pvRequestId);
    console.log('pvProxyRequestId', this.#pvProxyRequestId);
  }
}
